"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flatArray = flatArray;
exports.flatFilter = flatFilter;
exports.generateValueMaps = generateValueMaps;
exports.getRecordKeyByRowKey = getRecordKeyByRowKey;
exports.normalizeColumns = normalizeColumns;
exports.treeMap = treeMap;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function flatArray(_ref) {
  var _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    _ref$childrenName = _ref.childrenName,
    childrenName = _ref$childrenName === void 0 ? 'children' : _ref$childrenName,
    _ref$protectChildren = _ref.protectChildren,
    protectChildren = _ref$protectChildren === void 0 ? false : _ref$protectChildren;
  var result = [];
  var _loop = function loop(array) {
    array.forEach(function (item) {
      if (item[childrenName]) {
        var newItem = _objectSpread({}, item);
        if (!protectChildren) {
          delete newItem[childrenName];
        }
        result.push(newItem);
        if (item[childrenName].length > 0) {
          _loop(item[childrenName]);
        }
      } else {
        result.push(item);
      }
    });
  };
  _loop(data);
  return result;
}
function treeMap(tree, mapper) {
  var childrenName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
  return tree.map(function (node, index) {
    var extra = {};
    if (node[childrenName]) {
      extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
    }
    return _objectSpread(_objectSpread({}, mapper(node, index)), extra);
  });
}
function flatFilter(tree, callback) {
  return tree.reduce(function (acc, node) {
    if (callback(node)) {
      acc.push(node);
    }
    if (node.children) {
      var children = flatFilter(node.children, callback);
      acc.push.apply(acc, (0, _toConsumableArray2.default)(children));
    }
    return acc;
  }, []);
}
function normalizeColumns(elements) {
  var columns = [];
  React.Children.forEach(elements, function (element) {
    if (! /*#__PURE__*/React.isValidElement(element)) {
      return;
    }
    var column = _objectSpread({}, element.props);
    if (element.key) {
      column.key = element.key;
    }
    if (column.children && column.children.length > 0) {
      column.children = normalizeColumns(column.children);
    }
    columns.push(column);
  });
  return columns;
}
function generateValueMaps(items) {
  var maps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (items || []).forEach(function (_ref2) {
    var value = _ref2.value,
      children = _ref2.children;
    maps[value.toString()] = value;
    generateValueMaps(children, maps);
  });
  return maps;
}
function getRecordKeyByRowKey(rowKeyProp, record, index) {
  var value = {
    string: record[String(rowKeyProp)],
    function: typeof rowKeyProp == 'function' && rowKeyProp(record, index)
  };
  var rowKeyType = (0, _typeof2.default)(rowKeyProp);
  return value[rowKeyType] || record.key;
}